export default __webpack_public_path__ + "media/images/carousel/25-fd22242b344ace4e4edba8421f9b5bef.jpg";